import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@src/design-system/command';
import { useGetSubmissionsWithQuestions } from '@src/features/participants/services/use-get-submissions-with-questions';
import { useTableViewHelpers } from '@design-system/molecules/ticlick-table/hooks/use-table-view-helpers';
import { useTableStates } from '@src/design-system/molecules/ticlick-table/hooks/use-table-states';
import { useTiclickTableContext } from '@src/design-system/molecules/ticlick-table/context/ticlick-table-context-hook';
import { OPERATORS_ACC_TO_FILTER_TYPE } from '../../entities-filters/config';

import type { TQuestion } from '@shared/types/question';
import type { TField } from '@shared/types/field';

export function DynamicFilterFieldSelector({ index }: { index: number }) {
  const { table } = useTiclickTableContext();
  const tableViewEntityId = table.options.meta?.identifyingData.viewEntityId;

  const { data } = useGetSubmissionsWithQuestions({
    program: tableViewEntityId || 0,
    page_size: 10000,
  });
  const questions = data?.results[0].questions;

  const { updateDynamicFilter } = useTableViewHelpers();
  const { tableFilters } = useTableStates();
  const dynamicFilters = tableFilters?.dynamicFilters || [];

  const filterAlreadySelected = (q: TQuestion) =>
    !dynamicFilters.map((df) => df?.field?.id).includes(q?.id);

  const onClickQuestion = (question: TQuestion, index: number) => {
    updateDynamicFilter(
      {
        field: question as unknown as TField,
        operator: OPERATORS_ACC_TO_FILTER_TYPE[question.type][0],
        value: [],
      },
      index
    );
  };

  return (
    <Command>
      <CommandInput
        className='max-h-[32px]'
        placeholder='Search by name...'
      />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        <CommandGroup>
          {questions?.filter(filterAlreadySelected).map((question) => (
            <CommandItem
              key={question.id}
              value={`${question.title}-${question.id}`}
              onSelect={() => onClickQuestion(question, index)}
              className='p-1'
            >
              {question.title}
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </Command>
  );
}
